import {
  IGeocodedForSearchResponseItemDetailSchema,
} from '@cian/api-models/monolith-csharp/api/geo/geocoded-for-search';

export type IRegionInfo = IGeocodedForSearchResponseItemDetailSchema | undefined | null;

export const locationFromCurrentRegion = (
  regionInfo: IRegionInfo,
  regionTermValue: Array<number | string>,
  lastLocationsListItem: IRegionInfo,
) => {
  return (
    regionInfo
    && regionTermValue.includes(regionInfo.id)
    && !(lastLocationsListItem && lastLocationsListItem.locationInfo)
  );
};
